import script from "./PostersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PostersPage.vue?vue&type=script&setup=true&lang=js"

import "./PostersPage.vue?vue&type=style&index=0&id=ca35cccc&scoped=true&lang=css"
import "./PostersPage.vue?vue&type=style&index=1&id=ca35cccc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca35cccc"]])

export default __exports__